import Step from 'src/components/Step';
import StepperContext from 'src/store/stepper-context';
import { useContext } from 'react';
import LeasedAssetPage from 'src/pages/leased';
import LeasedAssetModal from 'src/components/modal/LeasedAssetModal';
import SkipItemizationMessageModal from 'src/components/modal/SkipItemizationMessageModal';
const LeasedAssetStep = (props) => {
  const { nextStep } = useContext(StepperContext);

  return (
    <Step
      component={<LeasedAssetPage />}
      onComplete={() => nextStep()}
      modals={[
        <LeasedAssetModal key="leasedAssetModal" />,
        <SkipItemizationMessageModal key="skipItemizationModal" />,
      ]}
      path={['/leased']}
      {...props}
    />
  );
};

export default LeasedAssetStep;
